import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { ChevronBackwardIcon } from "@jti/brand-icons/chevron-backward";
import { PinDefaultIcon } from "@jti/brand-icons/pin-default";
import { LinkBehaviour } from "../LinkBehaviour";
import styles from "./IconButton.module.scss";
export const IconButton = ({ children, className, variant, ...rest }) => {
    return (_jsxs(LinkBehaviour, { ...rest, className: classNames(styles.iconButton, className), children: [_jsx("span", { className: styles.icon, children: variant === "back" ? _jsx(ChevronBackwardIcon, {}) : _jsx(PinDefaultIcon, {}) }), _jsx("span", { className: styles.label, children: children })] }));
};
//# sourceMappingURL=IconButton.js.map